'use client'

import { SchemaManager } from '@/components/schema/schema-manager'
import { TCollectionFormatted } from '@/types/collection'
import { SchemaContent } from '@/types/schema'
import { ReactNode } from 'react'

interface BaseProps {
  children: ReactNode
  collectionId: string | number
  className?: string
  needBreadcrumb?: boolean
}

type CollectionLayoutProps =
  | (BaseProps & {
      needSchema: true
      collection: TCollectionFormatted
      slug: string
    })
  | (BaseProps & {
      needSchema?: false
      collection?: TCollectionFormatted
      slug?: string
    })

export const CollectionLayout = ({
  children,
  collectionId,
  className,
  collection,
  slug,
  needSchema,
  needBreadcrumb,
}: CollectionLayoutProps) => {
  const renderSchema = () => {
    const schemaContent = {
      gender: collection?.gender,
      seo_alias: collection?.detail?.seo_alias,
      images: collection?.detail?.images,
      title: collection?.title_display,
      review: collection?.detail?.review,
    } as SchemaContent

    if (needBreadcrumb) {
      const breadcrumbItems = [
        ...(collection?.breadcrumbs?.map((item) => ({
          title: item?.parent_name,
          href: `/collection/${item?.parent_slug}`,
        })) || []),
        {
          title: collection?.title_display ?? collection?.detail?.title ?? '',
        },
      ]

      schemaContent.breadcrumbs = breadcrumbItems
    }

    if (needSchema) {
      return (
        <SchemaManager
          pathname={`/collection/${slug}`}
          content={schemaContent}
        />
      )
    }
    return null
  }

  return (
    <main
      rel-script='collection'
      data-collection-id={collectionId}
      className={className}
    >
      {children}

      {renderSchema()}
    </main>
  )
}
